import React, { Component } from 'react';
import { CancelButton } from '../../../.common/Buttons/Cancel/CancelButton';
import { LayoutContext } from '../../../../modules/ContextModules/LayoutContext';
import './MinimizedWindowStatusItem.css'
export class MinimizedWindowStatusItem extends Component {
    static contextType = LayoutContext;

    render() {
        return (
            <div className={ this.status()} onClick={this.handleBodyClick}>
                {this.props.data.name}
                {this.props.data.name !== this.context.draggableWindowContext["socioeconomic"].name? <div className='minimizedWindowStatusItem__buttons'>
                    {/* <MinimizeButton width={25} height={25} onClick={this.handleMinimize}/> */}
                    {/* <MaximizeButton width={25} height={25} onClick={this.handleMaximize}/> */}
                     <CancelButton width={20} height={20} onClick={this.handleCancel} />
                </div>:null}
            </div>
        );
        
    }

    status = () => {
        return `minimizedWindowStatusItem 
        ${this.props.data.isOpened? 'minimizedWindowStatusItem--isOpened':''} 
        ${this.props.data.isMinimized? 'minimizedWindowStatusItem--isMinimized':''}`;
    }

    handleBodyClick = () => {
        this.props.handleBodyClick && this.props.handleBodyClick(this.props.data);        
    }

    handleCancel = (e) => {
        this.props.handleCancel && this.props.handleCancel(this.props.data);        
        e.stopPropagation();
    }
}